module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="form top-margined row">\r\n    <h4 class="center">Add new permission</h4>\r\n    <div class="col-md-5 col-xs-5">\r\n        <div id="owners-container" class="form-group"></div>\r\n        ';
 if (showOrganization == true) { 
__p+='\r\n        <div id="orgs-container" class="form-group"></div>\r\n        ';
 } 
__p+='\r\n    </div>\r\n    <div class="col-md-3 col-xs-3 col-md-offset-1 col-xs-offset-1">\r\n        <div data-toggle="can-view-tooltip" class="tooltipable">\r\n            <label class="checkbox"><input type="checkbox" id="can-read" value="canRead">Can view</label>\r\n        </div>\r\n        <!--<div class="tooltip top" role="can-view-tooltip">-->\r\n            <!--<div class="tooltip-arrow"></div>-->\r\n            <!--<div class="tooltip-inner">-->\r\n                <!--Can see-->\r\n            <!--</div>-->\r\n        <!--</div>-->\r\n\r\n\r\n        ';
 if (permittedObjectType != 'document') { 
__p+='\r\n        <label class="checkbox"><input type="checkbox" id="can-read-all" value="canReadAll">Can read all entities for</label>\r\n        ';
 } 
__p+='\r\n        ';
 if (permittedObjectType != 'document') { 
__p+='\r\n        <label class="checkbox"><input type="checkbox" id="can-read-for" value="canReadFor">Can read for</label>\r\n        ';
 } 
__p+='\r\n        <label class="checkbox"><input type="checkbox" id="can-write" value="canWrite">Can edit</label>\r\n        ';
 if (permittedObjectType != 'document') { 
__p+='\r\n        <label class="checkbox"><input type="checkbox" id="can-write-for" value="canWriteFor">Can edit for</label>\r\n        ';
 } 
__p+='\r\n        ';
 if (permittedObjectType != 'document') { 
__p+='\r\n        <label class="checkbox"><input type="checkbox" id="can-edit-all" value="canWriteAll">Can edit all</label>\r\n        ';
 } 
__p+='\r\n        <label class="checkbox"><input type="checkbox" id="can-delete" value="canDelete">Can delete</label>\r\n        <label class="checkbox"><input type="checkbox" id="can-sign" value="canSign">Can sign</label>\r\n        ';
 if (permittedObjectType != 'document') { 
__p+='\r\n        <label class="checkbox"><input type="checkbox" id="can-sign-all" value="canSignAll">Can sign for all</label>\r\n        ';
 } 
__p+='\r\n        ';
 if (permittedObjectType != 'document') { 
__p+='\r\n        <label class="checkbox"><input type="checkbox" id="can-upload-for" value="canUploadFor">Can upload for</label>\r\n        ';
 } 
__p+='\r\n        <label class="checkbox"><input type="checkbox" id="can-change-reviewer" value="canChangeReviewer">Can change\r\n            reviewer</label>\r\n\r\n        <div class="left-buttons">\r\n            <button type="button" class="btn btn-success" id="save-permission" disabled>Add</button>\r\n        </div>\r\n    </div>\r\n    <div class="col-md-3 col-xs-3">\r\n        <div data-toggle="collapse" data-target="#permission-templates">\r\n            <span class="dotted-link">Select from permissions templates</span>\r\n        </div>\r\n\r\n        <div class="collapse" style="margin: 20px 0px 20px 0px;" id="permission-templates">\r\n            <div id="permission-templates-list"></div>\r\n        </div>\r\n    </div>\r\n</div>\r\n\r\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/templates/permissions/permission-form.html
// module id = 247
// module chunks = 0